<mat-dialog-content>
  <app-absence-categories-legend [categoryId]="data.categoryId"></app-absence-categories-legend>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>
